export interface ChargePointGroupProps {
  chargeBoxGroupPk: number;
  name: string;
  status: true;
  address: {
    addressPk: 7;
    city: string;
    country: string;
    countryAlpha2OrNull: string;
    empty: boolean;
    houseNumber: string;
    state: string;
    street: string;
    zipCode: string;
  };
  locationLatitude: any;
  locationLongitude: any;
  externalId: string;
}

export interface ChargePointGroupsProps {
  error: any;
  list: ChargePointGroupProps[];
}

export enum ChargeBoxPhaseEnum {
  A = 'A',
  B = 'B',
  C = 'C',
  AB = 'AB',
  BA = 'BA',
  BC = 'BC',
  CB = 'CB',
  CA = 'CA',
  AC = 'AC',
  ABC = 'ABC',
  ACB = 'ACB',
  BAC = 'BAC',
  BCA = 'BCA',
  CAB = 'CAB',
  CBA = 'CBA',
}

export enum ChargingRateUnitEnum {
  A = 'A',
  W = 'W'
}

export enum ChargeBoxSystemEnum {
  SINGLE_PHASE = 'SINGLE_PHASE',
  TWO_PHASE = 'TWO_PHASE',
  THREE_PHASE = 'THREE_PHASE',
}
